import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import { formatPrice } from "utils/formatPrice"
import { formatPercentage } from "utils/formatPercentage"
import Tooltip from "components/Tooltip"
import InfoIconCard from "components/icons/IconInfoCard"
import styled from "styled-components"

const GrowthRateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const columns = [
  {
    Header: " ",
    columns: [
      {
        Header: () => <Heading variant="h6">Produto</Heading>,
        accessor: "product",
        Cell: (value: any) => {
          return (
            <BodyText size="medium" color="gray-dark">
              {value.cell.row.original.name}
            </BodyText>
          )
        }
      },
      {
        Header: () => <Heading variant="h6">Saldo liquido</Heading>,
        accessor: "netBalance",
        Cell: (value: any) => {
          const netBalance = formatPrice(value.cell.row.original.netBalance || 0, "BRL")

          return (
            <BodyText size="medium" color="gray-dark">
              {netBalance}
            </BodyText>
          )
        }
      },
      {
        Header: () => <Heading variant="h6">Novas contas</Heading>,
        accessor: "newAccounts",
        Cell: (value: any) => {
          return (
            <BodyText size="medium" color="gray-dark">
              {value.cell.row.original.newAccounts}
            </BodyText>
          )
        }
      },
      {
        Header: () => <Heading variant="h6">Eventos totais</Heading>,
        accessor: "eventsTotal",
        Cell: (value: any) => {
          return (
            <BodyText size="medium" color="gray-dark">
              {value.cell.row.original.eventsTotal}
            </BodyText>
          )
        }
      },
      {
        Header: () => <Heading variant="h6">Taxa de cancelamento</Heading>,
        accessor: "cancelRate",
        Cell: (value: any) => {
          const cancelRate = formatPercentage(value.cell.row.original.cancelRate || 0)

          return (
            <BodyText size="medium" color="gray-dark">
              {cancelRate}
            </BodyText>
          )
        }
      },
      {
        Header: () => (
          <GrowthRateContainer>
            <Heading variant="h6">Taxa de crescimento</Heading>
            <Tooltip
              toolTipClassName="position-absolute align-left"
              hoverClassName="positon-unset fit-content"
              text="Taxa de crescimento de eventos em relação ao período anterior"
            >
              <InfoIconCard />
            </Tooltip>
          </GrowthRateContainer>
        ),
        accessor: "growthRate",
        Cell: (value: any) => {
          const growthRate = formatPercentage(value.cell.row.original.growthRate || 0)

          return (
            <BodyText size="medium" color="gray-dark">
              {growthRate}
            </BodyText>
          )
        }
      }
    ]
  }
]
